import { createContext, useCallback, useState } from 'react';

export const BandStateContext = createContext();
export const BandDispatchContext = createContext();

export const BandProvider = ({ children }: { children: null | Node }) => {
  const [band, setBand] = useState(null);

  return (
    <BandDispatchContext.Provider value={{ setBand }}>
      <BandStateContext.Provider value={{ band }}>
        {children}
      </BandStateContext.Provider>
    </BandDispatchContext.Provider>
  );
};
